import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import UnregisteredShopDetailTable from '../../components/molecules/UnregisteredShopDetailTable';
import CloseButton from '../../components/atoms/CloseButton';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%'
    }
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('preGochiPage', 'setPreGochiPage', 0),
  withState('preGochiRowsPerPage', 'setPreGochiRowsPerPage', 5),
  withState('tagPage', 'setTagPage', 0),
  withState('tagRowsPerPage', 'setTagRowsPerPage', 5),
  withHandlers({
    handleChangePreGochiPage: props => (event, preGochiPage) => {
      props.setPreGochiPage(preGochiPage);
    },
    handleChangePreGochiRowsPerPage: props => event => {
      props.setPreGochiRowsPerPage(event.target.value);
    },
    handleChangeTagPage: props => (event, tagPage) => {
      props.setTagPage(tagPage);
    },
    handleChangeTagRowsPerPage: props => event => {
      props.setTagRowsPerPage(event.target.value);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, detail, updateOpenDetailModal }) => {
  const closeAction = () => updateOpenDetailModal(false);
  return (
    <div className={classes.root}>
      <Typography variant="h6">店舗情報詳細</Typography>
      <div>
        <UnregisteredShopDetailTable detail={detail} />
      </div>
      <div>
        <CloseButton onClickAction={closeAction} />
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
